<template>
  <div class="drawer-wrapper">
    <el-drawer :wrapperClosable="false" :title="title" :visible.sync="dialogVisible" size="60%"
               :before-close="handleClose" direction="rtl">

      <div class="demo-drawer__content">
        <el-form :model="addForm" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="章节序号" prop="index" :label-width="formLabelWidth">
                <el-input v-model="addForm.index" placeholder="请输入章节序号" clearable style="width: 90%;"
                  oninput="value = value.replace(/[^\d]/g, '')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="章节名称" prop="name" :label-width="formLabelWidth">
                <el-input v-model="addForm.name" placeholder="请输入章节名称" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="卷ID" prop="roll_id" :label-width="formLabelWidth">
                <el-input v-model="addForm.uid" placeholder="请输入卷ID" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="卷名称" prop="roll_name" :label-width="formLabelWidth">
                <el-input v-model="addForm.roll_name" placeholder="请输入卷名称" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="章节内容" prop="content" :label-width="formLabelWidth">
                <el-input v-model="addForm.content" type="textarea" :autosize="{ minRows: 14, maxRows: 100}" placeholder="请输入章节内容" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="付费锚点" prop="anchor_text" :label-width="formLabelWidth"
                :rules="[{ required: salesType == 1 && payChapter == addForm.index, message: '请输入付费锚点', trigger: 'blur' }]"
              >
                <el-input v-model="addForm.anchor_text" type="textarea" :autosize="{ minRows: 5, maxRows: 10}" placeholder="请输入付费锚点" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {KsNovalManagement} from "@/api/ksNovalManagement";
import {processErrors} from "@/utils/errorHandler";
const api = KsNovalManagement();
export default {
  props: ['dialogVisible', "editID","nid", "salesType", "payChapter", "currentTotal"],
  components: {},
  data() {
    const validateIndex = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入章节序号'));
      } else if(value == 0){
        callback(new Error('请输入大于0的数字'));
      } else {
        callback();
      }
    };
    const validateLength20 = function (rule, value, callback) {
      if(!value){
        callback(new Error('请输名称'));
      } else if(value.length > 20){
        callback(new Error('名称不能超过20个字'));
      } else {
        callback();
      }
    };
    return {
      title: "新增",
      formLabelWidth: "140px",
      addForm: {
        index:'',
        name: "",
        roll_id: "",
        roll_name: "",
        content: '',
        anchor_text: '',
      }, 
      rules: {
        index: [
          {required: true, message: '请输入章节序号', trigger: 'blur', validator: validateIndex},
        ],
        name: [
          { required: true, message: '', trigger: ['blur','change'], validator: validateLength20 },
        ],
        content: [
          {required: true, message: '请输入章节内容', trigger: 'blur'},
        ],
      },
    };
  },
  mounted() {
    if (this.editID != "") {
      api.ApiChapterInfo({
        id: this.editID,
        novel_id: this.nid,
      }).then(res => {
        if (res.code == 0) {
          this.title = "编辑"
          this.addForm = res.data
        } else {
          processErrors(res);
        }
      })
    }else{
      if(this.currentTotal || this.currentTotal == 0){
        this.addForm.index = Number(this.currentTotal) + 1
      }
    }
  },
  methods: {
    handleClose(done) {
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },

    AddNone() {
      this.addForm = {
        name: "",
        uid:'',
        ak: "",
        sk: "",
        is_use: 1,
        is_test: 1,
      }
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let createText = ''
          if (this.editID == "") {
            createText = "创建成功";
          } else {
            this.addForm.id = this.editID
            createText = "修改成功";
          }
          this.addForm.novel_id = this.nid

          api.ApiChapterEdit(this.addForm).then(res => {
            if (res.code == 0) {
              this.$message({
                message: createText,
                type: 'success'
              });
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          })
        } else {
          return false;
        }
      });
    }
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}
</style>